import { generateObjectId } from '../utils'

export interface ServiceFeeLineItem {
  fee: number
}

export interface GetServiceFeeParams {
  lineItems: ServiceFeeLineItem[]
  serviceFee: number | undefined | null
  discount?: number
  giftCardAmount?: number
}

// 100 was the legacy on/off switch for the solo service fee; it now maps to the 2%
// default. Any other value is already a real percentage.
export function normaliseServiceFeePercentage(serviceFee: number | undefined | null): number {
  return serviceFee === 100 ? 2 : (serviceFee ?? 0)
}

export interface GetServiceFeeItemParams {
  name: string
  category: string
  fee?: number
  id?: string
}

export const getServiceFeeItem = ({ name, category, fee, id }: GetServiceFeeItemParams) => {
  return {
    _id: id ?? generateObjectId(),
    fee: fee ?? 0,
    duration: 0,
    name,
    category,
  }
}

export function getServiceFee({
  lineItems,
  serviceFee,
  discount = 0,
  giftCardAmount = 0,
}: GetServiceFeeParams): number {
  if ((serviceFee ?? 0) <= 0) return 0
  const subtotal = Math.round(lineItems.reduce((sum, item) => sum + Number(item.fee), 0))
  const amount = Math.max(0, subtotal - Math.max(0, discount) - Math.max(0, giftCardAmount))

  if (amount === 0) return 0

  const percentage = normaliseServiceFeePercentage(serviceFee)
  return Math.round(amount * percentage / 100)
}
